<template>
  <div>
    <v-row>
      <v-col cols = '1'>
        <div v-if="error && !show" style="margin-top:25%; margin-left:25%">
          <v-icon color="var(--v-error-base)" v-once>mdi-alert</v-icon>
        </div>
      </v-col>
      <v-col cols = '11'>
        <div v-if="(!mutableList || mutableList.length == 0) && !show" style="margin-top:10px" class="d-flex align-center">
          <p class="ma-0">
            Añadir cuenta extra con referencia
          </p>
          <v-btn @click="add_account();show=!show"
          color="primary"
          icon>
          <v-icon >mdi-plus</v-icon>
          </v-btn>
        </div>
        <div v-else-if="!show" style="margin-top:5px" class="d-flex align-center">
          <p class="ma-0">
            {{mutableList.length}} cuentas extra con referencia
          </p>
          <v-btn @click="show=true"
          color="primary"
          icon
          >
          <v-icon >mdi-pencil</v-icon>
          </v-btn>
        </div>
        <div v-else style="margin-top:5px" class="d-flex align-center">
          <p class="ma-0">
            {{mutableList.length}} cuentas extra con referencia
          </p>
          <v-btn @click="show=false;clear_ref_accounts()"
          color="primary"
          icon
          >
          <v-icon >mdi-chevron-up-circle-outline</v-icon>
          </v-btn>
        </div>
      </v-col>
      
    </v-row>
    <v-simple-table class="rounded-lg detail-reference-accounts__table elevation-1 mb-5" dense v-if="show">
      <thead>
        <tr>
          <th colspan="3" class="pa-2">
            <v-btn small text color="primary" class="text-none" @click="add_account()">
              <v-icon small color="primary">
                mdi-plus
              </v-icon>
              Añadir cuenta
            </v-btn>
          </th>
        </tr>
        <tr>
          <th class="py-2 rounded-lg detail-reference-accounts__table__header primary--text">Cuenta</th>
          <th class="py-2 rounded-lg detail-reference-accounts__table__header primary--text">Referencia</th>
          <th class="py-2 rounded-lg detail-reference-accounts__table__header primary--text"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(acc,i) in mutableList" :key="i">
          <td class="pb-2 detail-reference-accounts__table__cell detail-reference-accounts__table__cell--has-borders" :class="i === mutableList.length - 1 ? 'rounded-bl-lg' : ''">
            <doc-text-field
            :kind='kind'
            v-model="acc['account']"
            @input="update"
            :max_length_account='max_length_account'
            :num_digits='num_digits'
            :items='items'
            :account_prefix_filter='account_prefix_filter'
            @get-values="getValues"
            @reset-items="resetItems"
            ></doc-text-field>
          </td>
          <td class="pb-2 detail-reference-accounts__table__cell detail-reference-accounts__table__cell--has-borders">
            <doc-text-field 
            v-model="acc['reference']"
            @input="update"
            ></doc-text-field>
          </td>
          <td class="pb-2 detail-reference-accounts__table__cell" :class="i === mutableList.length - 1 ? 'rounded-br-lg' : ''">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  small icon
                  color="primary"
                  class="mt-2"
                  v-on="on"
                  v-bind="attrs"
                  @click="remove_account(i)"
                >
                  <v-icon >
                    mdi-delete-outline
                  </v-icon>
                </v-btn>
              </template>
              Eliminar cuenta
            </v-tooltip>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import { createHelpers,mapFields } from 'vuex-map-fields';
import {mapFieldsMetadata,vuexPrefix} from "../store/vuex_utils"
import { mapActions, mapGetters } from "vuex"
import DocTextField from './DocTextField.vue'



export default {
  name: 'DetailReferenceAccounts',
  components:{
      DocTextField,
  },
  props: {
      accounts: {
        type:Array,
        default:[]
      },
      num_digits: {
        type: [Number, Boolean],
        default: false
      },
      max_length_account:{
        type: [Number, Boolean],
        default: false,
      },
      error: {
        type:Boolean,
        default:false
      },
      kind:{
        type:String,
        default: 'text', //account, account_am, number, text, date
      },
      items: {
        type: Array,
        default: function () {
                return [];
            },
        required: false
      },
      account_prefix_filter: {
        type: String,
        default: ''
      },
    },
  data(){
        return {
            mutableList: [],
            show:false,
        }
        
    },
  created(){
      for(let i in this.accounts){
        this.mutableList[i] = {...this.accounts[i]}
      }
  },
  computed:{
    ...mapFields('cru',vuexPrefix('cru_',['ref_expens_accounts'],'screenValues.supplierScreenValues.')),
    ...mapFields('cru',vuexPrefix('cru_error_',['ref_expens_accounts'],'screenErrors.supplierScreenValues.')),
    // errors(){
    //   if(this.cru_error_ref_expens_accounts){
    //     return this.cru_error_ref_expens_accounts
    //   }
    //   else{
    //     var err = []
    //     for (let i in this.cru_ref_expens_accounts) {
    //       err.push(false)
    //     }
    //     return err
    //   }
    // }
  },
  methods:{
      add_account(){
          let ref_account={}
          ref_account['account'] = ''
          ref_account['reference'] = ''
          this.mutableList.push(ref_account)
          this.update()
      },
      remove_account(i){
        this.mutableList.splice(i,1)
        this.update()
      },
      clear_ref_accounts(){
        for(let i = 0; i< this.mutableList.length;i++){
          if(this.mutableList[i]['account'] == ''){
            this.mutableList.splice(i,1)
            i--
          }
        }
        this.update()
      },
      update(){
        this.$emit('update', this.mutableList)
      },
      getValues(params) {
        this.$emit('get-values', params);
      },
      resetItems(params) {
        this.$emit('reset-items', params);
      },
  }
}
</script>
<style scoped>
.detail-reference-accounts__table {
  background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white) !important;
}

.detail-reference-accounts__table__header {
  background-color: var(--v-primaryLight-base) !important;
  border-radius: 0 !important;
}

.detail-reference-accounts__table__cell {
  background-color: #FFF !important;
}

.detail-reference-accounts__table__cell--has-borders {
  border-right: 1px solid var(--v-primary-base);
}
</style>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
</style>